import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkify',
})
export class LinkifyPipe implements PipeTransform {
  transform(text: string): string {
    const regex = /https:\/\/(www\.)?ec\.europa\.eu[^\s"]*/g;
    return text.replace(regex, (url) => {
      const href = url.startsWith('https') ? url : 'https://' + url;
      return `<a href="${href}" target="_blank">${url.replace('https://', '')}</a>`;
    });
  }
}
